const dialogSkin = {
  "@keyframes fadeIn": {
    "0%": { opacity: "0.1" },
    "66%": { opacity: " 0.5" },
    "100%": { opacity: "1" },
  },
  dialog: {
    composes: "modal",
  },
  "dialog-open": {
    ".modal&": {
      display: "block",
      opacity: "0",
      animation: "$fadeIn 0.15s ease 0s normal forwards 1",
    },
  },
  "dialog-closed": {
    ".modal&": {
      display: "none",
      opacity: "0",
      animation: "none",
    },
  },
  "dialog-header": {
    composes: "modal-header",
  },
  "dialog-title": {
    composes: "modal-title",
  },
  "dialog-close-button": {
    composes: "btn-close",
    "button&": {
      cursor: "pointer",
    },
  },
  "dialog-modal": {
    composes: "modal-dialog modal-xl",
  },
  "dialog-content": {
    composes: "modal-content",
  },
};

export default dialogSkin;
